import { splitLanguagePair } from './languagePairs';

export const normalizeTargetLangKey = (value?: string | null): string =>
  (value ?? '').toString().trim().replace(/ /g, '_');

export const normalizeLegacyTargetLangKey = (value?: string | null): string =>
  (value ?? '').toString().trim().replace(/-/g, '_').replace(/ /g, '_');

export const decodeBookPairKey = (value?: string | null): string =>
  (value ?? '').toString().trim().replace(/_/g, '-').replace(/0/g, ' ');

export const normalizeBookTermLists = (
  lists?: Record<string, string[]>
): Record<string, string[]> => {
  if (!lists) return {};
  return Object.entries(lists).reduce((acc, [key, value]) => {
    const normalizedKey = decodeBookPairKey(key);
    if (normalizedKey) {
      acc[normalizedKey] = Array.from(new Set([...(acc[normalizedKey] || []), ...(value || [])]));
    }
    return acc;
  }, {} as Record<string, string[]>);
};

const normalizeLookupKey = (value: string): string => value.trim().replace(/0/g, ' ')
  .replace(/->|→|[_-]/g, ' ').replace(/\s+/g, ' ').toLowerCase();

const mergeBuckets = (lists: Record<string, string[]> | undefined, candidates: string[]): string[] => {
  const keys = new Set(candidates.filter(Boolean).map(normalizeLookupKey));
  return Array.from(new Set(Object.entries(lists || {})
    .filter(([key]) => keys.has(normalizeLookupKey(key)))
    .flatMap(([, values]) => values || [])));
};

export const resolveBookTerms = (lists: Record<string, string[]> | undefined, pair: string): string[] =>
  mergeBuckets(lists, [pair]);

export const resolveAccountTerms = (lists: Record<string, string[]> | undefined, targetLang: string): string[] =>
  mergeBuckets(lists, [normalizeTargetLangKey(targetLang), normalizeLegacyTargetLangKey(targetLang), targetLang]);

export const resolveSeriesTerms = (lists: Record<string, string[]> | undefined, targetLang: string, pair?: string): string[] => {
  const { sourceLang, targetLang: pairTargetLang } = splitLanguagePair(pair || '');
  return mergeBuckets(lists, [targetLang, pair || '', sourceLang && pairTargetLang ? `${sourceLang}-${pairTargetLang}` : '']);
};
